/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast. Keeping your custom
 * Javascript in this file will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

// GiftBox debug — console me collapsed groups. Band karne ke liye:
//   window.GIFTBOX_DEBUG = false
var GiftBoxDebug = (function () {
  function enabled() {
    return typeof window.GIFTBOX_DEBUG === "boolean"
      ? window.GIFTBOX_DEBUG
      : true;
  }

  function log(group, message, data) {
    if (!enabled() || typeof console === "undefined") return;
    var label = "[GiftBox] " + group + " — " + message;
    if (console.groupCollapsed) {
      console.groupCollapsed(label);
      if (data !== undefined) console.log(data);
      console.groupEnd();
    } else {
      console.log(label, data !== undefined ? data : "");
    }
  }

  function warn(group, message, data) {
    if (!enabled() || typeof console === "undefined") return;
    console.warn("[GiftBox] " + group + " — " + message, data || "");
  }

  return { log: log, warn: warn, enabled: enabled };
})();

(function () {
  //==== START:: box code ====//
  var boxLog = GiftBoxDebug.log;
  var boxWarn = GiftBoxDebug.warn;

  // Sirf document cache — AJAX se replace nahi hota.
  // Baaki saare DOM refs LIVE query (AJAX ke baad bhi sahi node mile).
  var $doc = $(document);

  var step1 = false,
    step2 = false,
    step3 = false,
    step4 = false,
    currency = ($(".product-box-form").attr("data-currency") || "") + " ",
    tags = ".occasion.category",
    typed_text,
    selected_product_id,
    variant_id,
    product_counter,
    product_row,
    product_bottom_row,
    max_product_limit =
      parseFloat($(".custom-box-size-meter").attr("data-max-limit")) || 0,
    max_product_mini = parseFloat($(".mini").attr("data-size")) || 0,
    max_product_regular =
      (parseFloat($(".regular").attr("data-size")) || 0) + max_product_mini,
    max_product_big =
      (parseFloat($(".big").attr("data-size")) || 0) + max_product_regular,
    box_size = "Mini",
    mini_variant = $(".product-box-form").attr("data-mini-variant"),
    regular_variant = $(".product-box-form").attr("data-regular-variant"),
    big_variant = $(".product-box-form").attr("data-big-variant"),
    mini_variant_price = $(".product-box-form").attr(
      "data-mini-variant_price"
    ),
    regular_variant_price = $(".product-box-form").attr(
      "data-regular-variant_price"
    ),
    big_variant_price = $(".product-box-form").attr("data-big-variant_price"),
    variant_limit,
    individual_space_limit,
    individual_product_count,
    current_product_limit,
    progress_bar,
    cart_total,
    selected_product_title,
    total_steps = $(".custom-box-wrapper").attr("data-total-step"),
    cartClickLocked = false;

  boxLog("Init", "Box builder config loaded", {
    currency: currency,
    total_steps: total_steps,
    max_product_limit: max_product_limit,
    limits: {
      mini: max_product_mini,
      regular: max_product_regular,
      big: max_product_big,
    },
    variants: {
      mini: mini_variant,
      regular: regular_variant,
      big: big_variant,
    },
    prices: {
      mini: mini_variant_price,
      regular: regular_variant_price,
      big: big_variant_price,
    },
  });

  window.__giftboxState = function () {
    return {
      box_size: box_size,
      current_product_limit: current_product_limit,
      progress_bar: progress_bar,
      cart_total: cart_total,
      product_counter: product_counter,
      selected_product_id: selected_product_id,
      variant_id: variant_id,
      cartClickLocked: cartClickLocked,
      max_product_limit: max_product_limit,
    };
  };

  function $productEl(productId) {
    return $("." + productId);
  }

  function $productRows(productId) {
    return $('[data-product-row-id*="' + productId + '"]');
  }

  function getCurrentProductLimit() {
    var limit = 0;
    $(".box-contents-listing-product").each(function () {
      limit += parseFloat($(this).attr("data-current-count")) || 0;
    });
    return limit;
  }

  /**
   * Filter / sort AJAX ke baad naye product cards pe:
   * - max-reached classes
   * - tray me pehle se added products ki qty UI restore
   */
  function syncProductsAfterAjax() {
    current_product_limit = getCurrentProductLimit();

    $(".box-contents-listing-product").each(function () {
      var $row = $(this);
      var rowId = $row.attr("data-product-row-id");
      var qty = parseFloat($row.find(".quantity").text()) || 0;
      if (!rowId || qty <= 0) return;

      var $el = $productEl(rowId);
      if (!$el.length) return;

      $el.find(".cart-counter").text(qty);
      $el.find(".cart-quantity-selector").show();
      $el.find(".initial-add-to-cart").hide();
      $el.addClass("hasActive");
    });

    updateMaxReached(current_product_limit);

    boxLog("Ajax", "Grid synced after AJAX", {
      fill: current_product_limit,
      tray_items: $(".box-contents-listing-product").length,
    });
  }

  // Filter / sort handlers bahar se call kar sakein
  window.__giftboxSyncAfterAjax = syncProductsAfterAjax;

  function updateMaxReached(limit) {
    var $modalContent = $(".modal-content");

    $(".grid-product").each(function () {
      var $grid = $(this);
      var productLimit = limit + (parseFloat($grid.attr("data-space")) || 0);
      var id = $grid.attr("id");
      var $modalItem = id ? $modalContent.find("." + id) : $();

      if (productLimit > max_product_limit) {
        $grid.addClass("max-reached");
        $modalItem.addClass("max-reached");
      } else {
        $grid.removeClass("max-reached");
        $modalItem.removeClass("max-reached");
      }
    });
  }

  function updateBoxSize(limit) {
    var variant;
    var price;

    if (limit > max_product_mini && limit <= max_product_regular) {
      box_size = "Regular";
      variant = regular_variant;
      price = regular_variant_price;
    } else if (limit > max_product_regular) {
      box_size = "Big";
      variant = big_variant;
      price = big_variant_price;
    } else {
      box_size = "Mini";
      variant = mini_variant;
      price = mini_variant_price;
    }

    $(".product-select").val(variant);
    $(".base-product-price").attr("data-baseprice", price).text(price);
    $(".box-size").text(box_size);

    boxLog("BoxSize", "Size / variant updated", {
      limit: limit,
      box_size: box_size,
      variant: variant,
      price: price,
    });
  }

  function updateProgress(limit, addOffset) {
    progress_bar = (limit / max_product_limit) * 100;
    if (addOffset) {
      progress_bar += 5;
    } else if (progress_bar === 0) {
      progress_bar = 5;
    }
    $(".size-meter-mask").css("left", progress_bar + "%");
    $(".progress").css("width", progress_bar + "%");
    progress_text(progress_bar);

    boxLog("Progress", "Meter updated", {
      limit: limit,
      max: max_product_limit,
      progress_bar: progress_bar,
      addOffset: !!addOffset,
    });
  }

  function updateRowQuantity($rows, count, spaceCount, withCurrency) {
    var $price = $rows.find(".price");
    var basePrice = parseFloat($price.attr("data-baseprice")) || 0;
    var newPrice = basePrice * count;
    var priceText = withCurrency
      ? currency + newPrice.toFixed(2)
      : newPrice.toFixed(2);

    $price.text(priceText);
    $rows.find(".quantity").text(count);
    $rows.attr("data-current-count", spaceCount);
    $rows.find(".quantity-badge").text(count);
  }

  function resetProductQuantityUI($el) {
    $el.find(".all-quantity-added").text("");
    $el.find(".plus-selector").removeClass("limit-reached");
  }

  function goToStep2() {
    step1 = true;
    $(".step-1-wrapper").addClass("hide");
    $(".step-2-wrapper").removeClass("hide");
    $("#step-choose-items").addClass("active");
    window.scrollTo(0, 0);
    boxLog("Steps", "Moved to step 2 (choose items)", {
      total_steps: total_steps,
    });
  }

  function goToStep3() {
    $("#step-choose-card").addClass("active").removeClass("step-locked");
    $(".step-3-wrapper").removeClass("hide");
    $(".step-2-wrapper").addClass("hide");
    $(".step-1-wrapper").addClass("hide");
    $(".fixed-tray").addClass("hide");
    $(".previous-btn").removeClass("hide");
    boxLog("Steps", "Moved to step 3 (card / message)", {
      current_product_limit: current_product_limit,
    });
  }

  function validateCardFields() {
    if ($(".blank-checkbox input:checked").val() != "Yes") {
      if (
        $("#to").val() == "" ||
        $("#from").val() == "" ||
        $(".message-box").val() == ""
      ) {
        boxWarn("Validation", "Card fields incomplete (to / from / message)");
        $("#myModal").show();
        $(".popup-content").html("Please fill all fields.");
        return false;
      }
    } else {
      $("#to").val("");
      $("#from").val("");
      $(".message-box").val("");
      boxLog("Validation", "Blank card selected — clearing message fields");
    }
    return true;
  }

  //======= step1 =======//
  $doc.on("click", ".step-1-wrapper a", function () {
    $(".step-1-wrapper a").removeClass("step1-selected");
    $(this).addClass("step1-selected");
    $(".selected-box-color").val($(this).attr("data-title"));
    $(".previous-btn").removeClass("hide");
    if (product_counter > 0) {
      $("#custom-giftbox-tray").removeClass("hide");
    }
    goToStep2();
  });

  if (total_steps == 3) {
    goToStep2();
  }

  //===== filter ======//
  $doc.on("change", ".filter-dropdown", function () {
    tags = "";
    var tags_arry = [];

    $(".filter-dropdown").each(function () {
      var $dropdown = $(this);
      tags += "." + $dropdown.val();
      tags_arry.push($dropdown.find(":selected").attr("data-tag"));
    });

    boxLog("Filter", "Dropdown filter applied", {
      tags: tags,
      tags_arry: tags_arry,
    });

    applyFilter(tags_arry);

    if ($(tags).length === 0) {
      $(".error-msg").removeClass("hide");
    } else {
      $(".error-msg").addClass("hide");
    }
  });

  $doc.on("keyup", ".filter-input", function () {
    typed_text = ($(this).val() || "").toLowerCase();
    var $tagged = $(tags);
    var hasMatch = false;

    $tagged.addClass("hide");
    $tagged.each(function () {
      var product_title = ($(this).attr("data-title") || "").toLowerCase();
      if (product_title.indexOf(typed_text) !== -1) {
        $(this).removeClass("hide");
        hasMatch = true;
      }
    });

    if (hasMatch) {
      $(".error-msg").addClass("hide");
    } else {
      $(".error-msg").removeClass("hide");
    }
  });

  $doc.on("change", ".col-occasion", function () {
    window.location.href = $(this).val();
  });

  $doc.on("click", ".minus-selector", function () {
    var $btn = $(this);
    selected_product_id = $btn.attr("data-product-id");
    individual_space_limit = parseFloat($btn.attr("data-max-limit")) || 0;

    var $el = $productEl(selected_product_id);
    resetProductQuantityUI($el);

    product_counter =
      (parseFloat($el.find(".cart-counter").eq(0).text()) || 0) - 1;
    $el.find(".cart-counter").text(product_counter);

    individual_product_count = individual_space_limit * product_counter;

    if (product_counter === 0) {
      $el.find(".initial-add-to-cart").show();
      $el.find(".cart-quantity-selector").hide();
      $el.removeClass("hasActive");
      $productRows(selected_product_id).remove();
    } else {
      updateRowQuantity(
        $productRows(selected_product_id),
        product_counter,
        individual_product_count,
        true
      );
    }

    current_product_limit = getCurrentProductLimit();
    updateMaxReached(current_product_limit);
    updateBoxSize(current_product_limit);
    updateProgress(current_product_limit, false);
    cartSubTotal();

    boxLog("Qty", "Minus — quantity decreased", {
      product_id: selected_product_id,
      qty: product_counter,
      space_used: individual_product_count,
      box_fill: current_product_limit,
      removed_from_tray: product_counter === 0,
    });
  });

  $doc.on("click", ".plus-selector", function () {
    var $btn = $(this);
    $("#custom-giftbox-tray").removeClass("hide");

    selected_product_id = $btn.attr("data-product-id");
    individual_space_limit = parseFloat($btn.attr("data-max-limit")) || 0;
    selected_product_title = $btn.attr("data-title");
    variant_limit = parseFloat($btn.attr("data-variant-inventory")) || 0;

    var $el = $productEl(selected_product_id);
    resetProductQuantityUI($el);

    var currentCount =
      parseFloat($el.find(".cart-counter").eq(0).text()) || 0;

    if (currentCount === variant_limit) {
      boxWarn("Qty", "Stock limit reached — plus blocked", {
        product_id: selected_product_id,
        currentCount: currentCount,
        variant_limit: variant_limit,
      });
      $el.find(".all-quantity-added").text("Stock limit has been reached.");
      $el.find(".plus-selector").addClass("limit-reached");
      return false;
    }

    product_counter = currentCount + 1;
    individual_product_count = individual_space_limit * product_counter;
    current_product_limit =
      getCurrentProductLimit() + individual_space_limit;

    if (max_product_limit < current_product_limit) {
      boxWarn("Qty", "Box capacity exceeded — plus blocked", {
        product_id: selected_product_id,
        attempted_fill: current_product_limit,
        max_product_limit: max_product_limit,
        space_per_item: individual_space_limit,
      });
      return false;
    }

    updateMaxReached(current_product_limit);
    updateBoxSize(current_product_limit);
    updateProgress(current_product_limit, true);

    $el.find(".cart-counter").text(product_counter);
    $el.find(".cart-quantity-selector").show();
    $el.addClass("hasActive");
    variant_id = $el.attr("data-variant-id");

    if (product_counter === 1) {
      product_row =
        '<div class="box-contents-listing-product ajax-required" data-variant-id="' +
        variant_id +
        '" data-product-row-id="' +
        selected_product_id +
        '" data-product-space="' +
        individual_space_limit +
        '" data-current-count="' +
        individual_product_count +
        '" data-title="' +
        selected_product_title +
        '">' +
        '<img src="' +
        $btn.attr("data-image") +
        '">' +
        '<div class="box-contents-listbox-contents-listing-product-text uniform-designing-product-text quantity uniform-design">' +
        product_counter +
        "</div>" +
        '<div class="box-contents-listing-product-text product-row-title uniform-design">' +
        $btn.attr("data-title") +
        "</div>" +
        '<div class="price box-contents-listing-product-text uniform-design" data-baseprice="' +
        $btn.attr("data-money-without-price") +
        '">' +
        $btn.attr("data-price") +
        "</div>" +
        '<div class="close-button" data-remove="' +
        selected_product_id +
        '"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 37 40"><path d="M21.3 23l11-11c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0l-11 11-11-11c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l11 11-11 11c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l11-11 11 11c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8l-11-11z"></path></svg></div>' +
        "</div>";

      product_bottom_row =
        '<li class="ng-scope" data-product-row-id="' +
        selected_product_id +
        '">' +
        '<a href="javascript:void(0)">' +
        '<img title="' +
        $btn.attr("data-title") +
        '" src="' +
        $btn.attr("data-image") +
        '">' +
        '<div class="quantity-badge ng-binding">' +
        product_counter +
        "</div>" +
        "</a>" +
        "</li>";

      $(".listing-products").append(product_row);
      $(".giftbox-images").append(product_bottom_row);
      boxLog("Qty", "Plus — new product row added to tray", {
        product_id: selected_product_id,
        title: selected_product_title,
        variant_id: variant_id,
        qty: product_counter,
        space: individual_product_count,
        box_fill: current_product_limit,
      });
    } else {
      updateRowQuantity(
        $productRows(selected_product_id),
        product_counter,
        individual_product_count,
        false
      );
      boxLog("Qty", "Plus — existing product qty increased", {
        product_id: selected_product_id,
        variant_id: variant_id,
        qty: product_counter,
        space: individual_product_count,
        box_fill: current_product_limit,
      });
    }

    cartSubTotal();
  });

  $doc.on("click", ".initial-add-to-cart", function () {
    var $btn = $(this);
    selected_product_id = $btn.attr("data-product-id");
    current_product_limit = getCurrentProductLimit();

    updateMaxReached(current_product_limit);

    current_product_limit +=
      parseFloat($btn.next().find(".plus-selector").attr("data-max-limit")) ||
      0;

    if (max_product_limit < current_product_limit) {
      boxWarn("Qty", "Initial add blocked — box full", {
        product_id: selected_product_id,
        attempted_fill: current_product_limit,
        max_product_limit: max_product_limit,
      });
      return false;
    }

    boxLog("Qty", "Initial add — triggering plus", {
      product_id: selected_product_id,
      projected_fill: current_product_limit,
    });

    $productEl(selected_product_id).find(".initial-add-to-cart").hide();
    $btn.next().find(".plus-selector").trigger("click");
  });

  $doc.on("click", ".next-step", function () {
    window.scrollTo(0, 0);
    var content = $(this).attr("data-error");

    if (current_product_limit == 0 || current_product_limit == undefined) {
      boxWarn("Steps", "Next step blocked — box empty", {
        current_product_limit: current_product_limit,
      });
      $("#myModal").show();
      $(".popup-content").html(content);
      return false;
    }

    goToStep3();
  });

  $doc.on("click", ".quickview-trigger", function (e) {
    e.preventDefault();
    $("." + $(this).attr("data-quickview")).css("display", "flex");
  });

  $doc.on("click", ".close", function () {
    $(".modal-quickview").hide();
  });

  $doc.on("click", ".show-popup", function () {
    window.scrollTo(0, 0);
    $("#myModal").hide();
    var content = $(this).attr("data-error");

    if (current_product_limit == 0 || current_product_limit == undefined) {
      $("#myModal").show();
      $(".popup-content").text(content);
      return false;
    }

    goToStep3();
  });

  $doc.on("click", ".show-error", function () {
    $("#myModal").show();
    $(".popup-content").html($(this).attr("data-error"));
    return false;
  });

  $doc.on("click", ".close-modal", function () {
    $("#myModal").hide();
  });

  $doc.on("click", ".step3-content", function () {
    var $card = $(this);
    $("#myModal").hide();
    $("#selected-card-img").attr("src", $card.find("img").attr("src"));
    $(".card-wrapper").addClass("hide");
    $(".message-section").removeClass("hide");
    $(".selected-card-input").val($card.attr("data-card-text"));
  });

  $doc.on("click", ".change-card", function () {
    $("#myModal").hide();
    $(".card-wrapper").removeClass("hide");
    $(".message-section").addClass("hide");
  });

  //==== steps back and forward ====//
  $doc.on("click", "#step-choose-packaging", function () {
    $("#myModal").hide();
    if ($(this).hasClass("active")) {
      $(".step-1-wrapper").removeClass("hide");
      $(".step-2-wrapper, .step-3-wrapper, .step-4-wrapper, .fixed-tray").addClass(
        "hide"
      );
      $(".previous-btn").addClass("hide");
    }
  });

  $doc.on("click", "#step-choose-items", function () {
    if ($(this).hasClass("active")) {
      $(".step-1-wrapper, .step-3-wrapper").addClass("hide");
      $(".step-2-wrapper, .fixed-tray").removeClass("hide");
      if (total_steps != 3) {
        $(".previous-btn").removeClass("hide");
      }
    }
  });

  $doc.on("click", "#step-choose-card", function () {
    if ($(this).hasClass("active")) {
      $(".next-step").trigger("click");
    }
  });

  $doc.on("click", ".previous-btn", function () {
    if ($(".step-2-wrapper").is(":visible")) {
      $("#step-choose-packaging").trigger("click");
      $(".previous-btn").addClass("hide");
    } else if ($(".step-3-wrapper").is(":visible")) {
      $("#step-choose-items").trigger("click");
    }
  });

  function progress_text(bar) {
    var text = "";
    if (bar == 5) {
      text = "Your box is feeling empty. Start adding your items!";
    } else if (bar > 5 && bar <= 50) {
      text = "You're off to a great start. Keep going!";
    } else if (bar > 50 && bar <= 75) {
      text = "Looking good!";
    } else if (bar > 75 && bar < 100) {
      text = "It's getting cozy in there, but you can squeeze more in!";
    } else if (bar == 100) {
      text = "Your box is full!";
    }
    if (text) {
      $("#box-contents-listing-progress-text").text(text);
    }
  }

  function cartSubTotal() {
    cart_total = 0;
    $(".box-contents-listing-product").each(function () {
      var $row = $(this);
      var qty = parseFloat($row.find(".quantity").text()) || 0;
      var price = parseFloat($row.find(".price").attr("data-baseprice")) || 0;
      cart_total += qty * price;
    });
    var totalText = cart_total.toFixed(2);
    $("#box-contents-listing-subtotal").text("Subtotal " + totalText);
    $(".subtotal").text(totalText);

    boxLog("Cart", "Subtotal recalculated", {
      cart_total: cart_total,
      currency: currency,
      box_size: box_size,
      fill: current_product_limit,
    });
  }

  // Bound once — was previously re-bound on every product append (duplicate AJAX risk)
  $doc.on("click", ".close-button", function () {
    var delete_id = $(this).attr("data-remove");
    var $el = $productEl(delete_id);

    product_counter = 0;
    $el.find(".initial-add-to-cart").show();
    $el.find(".cart-quantity-selector").hide();
    $el.removeClass("hasActive");
    $el.find(".cart-counter").text(product_counter);
    resetProductQuantityUI($el);
    $productRows(delete_id).remove();

    current_product_limit = getCurrentProductLimit();
    updateMaxReached(current_product_limit);
    updateBoxSize(current_product_limit);
    updateProgress(current_product_limit, false);

    if (current_product_limit === 0) {
      $("#custom-giftbox-tray").addClass("hide");
    }

    boxLog("Qty", "Product removed from tray", {
      product_id: delete_id,
      box_fill: current_product_limit,
      tray_empty: current_product_limit === 0,
    });

    cartSubTotal();
  });

  $doc.on("click", ".add-to-cart-box", function (e) {
    e.preventDefault();

    if (!validateCardFields()) {
      return false;
    }

    $(".step-3-wrapper").addClass("hide");
    $(".step-4-wrapper").removeClass("hide");
    window.scrollTo(0, 0);

    setTimeout(function () {
      if (cartClickLocked) {
        boxWarn("Cart", "Add-to-cart ignored — already in progress (locked)");
        return;
      }

      var $ajaxItems = $(".ajax-required");
      var numberOfPendingRequests = 0;
      var selectedProductTitle = "";
      var selected_box_color = $(".selected-box-color").val();
      var box_number = $(".box_number").val();
      var x = 1;
      var cartPayload = [];

      $ajaxItems.each(function () {
        if ($(this).attr("data-variant-id") != undefined) {
          numberOfPendingRequests++;
        }
      });

      boxLog("Cart", "Box add-to-cart started", {
        pending: numberOfPendingRequests,
        box_number: box_number,
        box_color: selected_box_color,
        box_size: box_size,
        fill: current_product_limit,
        subtotal: cart_total,
      });

      $ajaxItems.each(function () {
        var $item = $(this);
        var variant = $item.attr("data-variant-id");
        var data_title = $item.attr("data-title");
        var qnt_value = $item.find(".quantity").text();

        selectedProductTitle +=
          "(" +
          x +
          "): Title:" +
          data_title +
          ", Quantity: " +
          qnt_value +
          " ";

        if (variant != undefined) {
          cartPayload.push({
            id: variant,
            title: data_title,
            quantity: qnt_value,
          });

          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            async: false,
            data: {
              quantity: qnt_value,
              id: variant,
              properties: {
                "Box No": box_number,
                "Box Color": selected_box_color,
              },
            },
            dataType: "json",
            success: function () {
              numberOfPendingRequests--;
              boxLog("Cart", "Line item added", {
                variant: variant,
                title: data_title,
                quantity: qnt_value,
                remaining: numberOfPendingRequests,
              });
              if (numberOfPendingRequests === 0) {
                boxLog("Cart", "All box items added — submitting form", {
                  items: cartPayload,
                  selectedProductTitle: selectedProductTitle,
                });
                $(".spinner").addClass("hide");
                $(".ajax-done").removeClass("hide");
                setTimeout(function () {
                  $(".product-box-form").submit();
                }, 200);
              }
            },
            error: function (xhr) {
              boxWarn("Cart", "Line item add failed", {
                variant: variant,
                status: xhr && xhr.status,
                response: xhr && xhr.responseText,
              });
            },
          });
        }
        x++;
      });

      cartClickLocked = true;
    }, 100);
  });

  $doc.on("click", ".giftbox-images li", function () {
    var target_id = ($(this).attr("data-product-row-id") || "").split("-")[1];
    $(".modal-quickview").hide();
    $(".quickview-" + target_id).css("display", "flex");
  });

  $doc.on("keypress", "#message", function () {
    var rest = 149 - this.value.length;
    if (rest >= 0) {
      $(".count-remaining").text(rest + " characters remaining");
    } else {
      return false;
    }
  });

  //==== box code ====//
  $doc.on("click", ".btn--add-to-cart", function (e) {
    e.preventDefault();
    if ($("body").hasClass("template-product")) {
      return;
    }

    if (!validateCardFields()) {
      return false;
    }

    var $selectedVariant = $(".product-variants option:selected");
    var variant_inventory =
      parseFloat($selectedVariant.attr("data-quantity")) || 0;
    var quantity = parseFloat($("#quantity").val()) || 0;
    var selectedVariantId = $selectedVariant.attr("value");

    boxLog("Cart", "PDP add-to-cart clicked", {
      variant_id: selectedVariantId,
      quantity: quantity,
      inventory: variant_inventory,
    });

    jQuery.getJSON("/cart.js", function (cart) {
      var next_limit;

      if (cart.item_count > 0) {
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].variant_id) === String(selectedVariantId)) {
            next_limit = variant_inventory - cart.items[i].quantity;
            boxLog("Cart", "Variant already in cart — checking remaining stock", {
              in_cart_qty: cart.items[i].quantity,
              next_limit: next_limit,
              requested: quantity,
            });
            if (next_limit === 0) {
              $(".all-quantity-added").text("Stock limit has been reached");
            } else if (next_limit > 0 && quantity <= next_limit) {
              addProduct();
            } else {
              $(".all-quantity-added").text(
                "Only " + variant_inventory + " available"
              );
            }
            break;
          }
        }

        if (next_limit === undefined || next_limit === "") {
          if (quantity > variant_inventory) {
            boxWarn("Cart", "Requested qty exceeds inventory", {
              quantity: quantity,
              inventory: variant_inventory,
            });
            $(".all-quantity-added").text(
              "Only " + variant_inventory + " available"
            );
          } else {
            addProduct();
          }
        }
      } else if (quantity > variant_inventory) {
        boxWarn("Cart", "Requested qty exceeds inventory (empty cart)", {
          quantity: quantity,
          inventory: variant_inventory,
        });
        $(".all-quantity-added").text(
          "Only " + variant_inventory + " available"
        );
      } else {
        addProduct();
      }
    });
  });

  function addProduct() {
    var formData = $(".addToCartForm").serialize();
    boxLog("Cart", "addProduct POST /cart/add", { formData: formData });

    $.ajax({
      type: "POST",
      url: "/cart/add",
      data: formData,
      success: function () {
        jQuery.getJSON("/cart.js", function (cart) {
          boxLog("Cart", "Product added — cart updated", {
            item_count: cart.item_count,
          });
          $(".cart-count").removeClass("hidden-count").text(cart.item_count);
          $("#myModal").show();
          $(".popup-content").html(
            'Item is added to cart. <br><a href="/" >Continue Shopping?</a> <a href="/cart" class="btn ">View Cart</a>'
          );
          $(".popup-content").next().remove();
        });
      },
      error: function (xhr) {
        boxWarn("Cart", "addProduct failed", {
          status: xhr && xhr.status,
          response: xhr && xhr.responseText,
        });
      },
    });
  }

  var $gridImages = $(".product-grid-image");
  if ($gridImages.length) {
    var maxHeight = Math.max.apply(
      null,
      $gridImages
        .map(function () {
          return $(this).height();
        })
        .get()
    );
    $gridImages.css("height", maxHeight);
  }

  $doc.on("change", ".single-option-selector", function () {
    var data_image_id = $(
      "#productSelect-product-template option:selected"
    ).attr("data-image-id");
    var data_slick_index = $("#" + data_image_id)
      .parent()
      .parent()
      .attr("data-slick-index");
    $(".product-photo-container").slick("slickGoTo", data_slick_index);
  });
})();

function textCounter(field, field2, maxlimit) {
  var countfield = document.getElementById(field2);
  if (field.value.length > maxlimit) {
    field.value = field.value.substring(0, maxlimit);
    return false;
  }
  countfield.value = maxlimit - field.value.length;
}

$(window).on("load", function () {
  $.getJSON("/cart.json", function (cart) {
    var item_id = $(".product-box-form").attr("data-productid");
    var x = 0;

    $.each(cart.items, function (key, value) {
      if (item_id == value.product_id) {
        x += 1;
      }
    });

    var new_number = x + 1;
    $(".box_number").val(new_number);
    GiftBoxDebug.log("Init", "Box number assigned from cart", {
      product_id: item_id,
      existing_boxes: x,
      box_number: new_number,
    });
  });
});

function boxRemove(boxNumber) {
  var $boxItems = $("[data-box=" + boxNumber + "]");
  var parts = [];

  $boxItems.each(function () {
    parts.push("updates[" + $(this).attr("data-variant") + "]=0");
  });

  GiftBoxDebug.log("Cart", "Removing entire box", {
    boxNumber: boxNumber,
    payload: parts.join("&"),
  });

  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: parts.join("&"),
    success: function () {
      window.location.href = "/cart";
    },
    error: function () {
      window.location.href = "/cart";
    },
  });
}

//==== END:: box code ====//
$(document).on("click", ".build-popout .popout", function () {
  $(".popout").parent().toggleClass("is-visible");
});

$(document).on("click", ".new--add_to_cart", function () {
  $($(this).attr("data-target")).find(".initial-add-to-cart").click();
});

$(document).on("click", ".qv_thumbnail", function () {
  var $el = $(this);
  var thumbSrc = $el.find("img").attr("data-src");
  $el
    .parents(".product-content-wrapper")
    .find(".qv_main--image img")
    .attr("src", thumbSrc);
});

$(document).on("click", "#build-sort-list .popout-list__option", function () {
  var $el = $(this);
  var value = $el.attr("data-value");
  var datatext = $el.find("span").text();
  var URL = updateQueryStringParameter(window.location.href, "sort_by", value);

  $(".popout").addClass("is-active");
  $(".popout__toggle__text[data-sort-button-text]").text(datatext);
  $(".popout-list__item").removeClass("is-active");
  $el.parent(".popout-list__item").addClass("is-active");
  history.pushState({}, null, URL);
  $(".product-grid-outer").css("opacity", "0.5");

  GiftBoxDebug.log("Sort", "AJAX grid refresh", {
    sort_by: value,
    label: datatext,
    url: URL,
  });

  fetch(URL)
    .then(function (response) {
      return response.text();
    })
    .then(function (data) {
      var dd = $(data).find(".product-grid-outer").html();
      $(".product-grid-outer").html(dd).css("opacity", "");
      if (typeof window.__giftboxSyncAfterAjax === "function") {
        window.__giftboxSyncAfterAjax();
      }
    });
});

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  }
  return uri + separator + key + "=" + value;
}

setTimeout(function () {
  if ($(".modal__overlay--newsletter:visible").length === 0) {
    $("body").removeClass("popup_modal--active");
  } else {
    $("body").addClass("popup_modal--active");
  }

  $(document).on("click", ".modal__overlay--newsletter .close", function () {
    $("body").removeClass("popup_modal--active");
  });
}, 2000);

$(document).on("click", ".new--add-to-cart", function () {
  $(this).parents(".product-item__image").find(".product-link").click();
});

$(document).on("click", ".select_label", function () {
  var select_variant = $(this)
    .parents(".radio__buttons")
    .find(".select_variant")
    .val();
  $(".select_label").removeClass("active");
  $('input[value="' + select_variant + '"]')
    .trigger("click")
    .prop("checked", true);
  $(this).addClass("active");
});

$(document).on("change", ".select_variant", function () {
  var $item = $(this).parents(".product-item");
  var input = $(this).val();
  $item.attr("data-variant-id", input);
  $item.find(".initial-add-to-cart").show();
  $item.find(".cart-quantity-selector").hide();
  GiftBoxDebug.log("Variant", "Product variant changed", {
    variant_id: input,
  });
});

$(document).on("click", ".accordion_content li[data-target]", function () {
  var $li = $(this);
  var $item = $li.closest(".accordion_item");

  $($li.data("target")).val($li.attr("value")).change();
  $item.find(".accordion_content").css("maxHeight", "");
  $item
    .find(".accordion_button")
    .removeClass("active")
    .find("[data-value]")
    .html($li.data("title"));
});

function applyFilter(tags) {
  var tagString = tags.length ? "/" + tags.join("+") : "";
  var url = window.collection_url + tagString + "?view=ajax";

  GiftBoxDebug.log("Filter", "Fetching filtered products", {
    tags: tags,
    url: url,
  });

  fetch(url)
    .then(function (res) {
      return res.text();
    })
    .then(function (html) {
      var container = document.querySelector("#build-your-carton-products");
      if (container) {
        container.innerHTML = html;
        if (typeof window.__giftboxSyncAfterAjax === "function") {
          window.__giftboxSyncAfterAjax();
        }
      } else {
        GiftBoxDebug.warn(
          "Filter",
          "#build-your-carton-products not found"
        );
      }
    })
    .catch(function (err) {
      GiftBoxDebug.warn("Filter", "fetch failed", err);
    });
}
